module.exports = __webpack_public_path__ + "static/media/info.f0f2d4d8.svg";